import React, { useRef, useState } from 'react';
import { useOutsideAlerter } from 'Services/helpers';
import CssHelper from 'Services/Utils/Css/CssHelper';
import BaseField from '../BaseField/BaseField';
import styles from './TextField.module.sass';

const TextField = ({
    iconBefore,
    iconAfter,
    size,
    disableBlur,

    placeholder,
    value,
    onChange,

    ...props
}: Props) => {
    const [state, setState] = useState({
        isFocused: false
    });

    const inputRef = useRef<any>(null);

    const handleChange = (value: any) => onChange(value?.target?.value ?? '');

    const handleBlur = () => {
        if (!disableBlur) {
            onChange(value?.trim());
        }
    }

    const handleFocus = (value: boolean) => {
        if (value) {
            inputRef?.current?.focus();
        }

        // @ts-ignore
        props?.onClick();
    }

    return <BaseField
        onFocus={handleFocus}
        hasValue={!!value}
        size={size ?? 'medium'}
    >
        <input
            className={styles['textfield']}
            ref={inputRef}
            onChange={handleChange}
            onBlur={handleBlur}
            value={value}
            placeholder={placeholder}
        />    
    </BaseField>
}

interface Props {
    iconBefore?: any
    iconAfter?: any
    size?: 'small' | 'medium' | 'large'
    placeholder?: string
    disableBlur?: boolean

    value: string
    onChange: any
}

export default React.memo(TextField);